enum ChatEvent {
  ConnectError = 'connect_error',
  MessageReceived = 'message_received',
}

export default ChatEvent
